'use client';

import type {
  ProductDetailData,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';

export function ProductTabsParameters({
  product,
  selectedVariant,
}: {
  product: ProductDetailData;
  selectedVariant?: VariantsEntity;
}) {
  return <div>Parameters TAB</div>;
}
